import { APPLICATIONS } from '@/services/consts/application';

export default {
  path: '/real-time',
  name: 'r_real-time',
  meta: {
    middlewares: {
      auth: null,
      permission: 'REAL_TIME',
      document: { applicationId: APPLICATIONS.APP_REAL_TIME.id },
      menuPreferences: 'REAL_TIME',
    },
  },
  component: () => import('../../components/realtime/Realtime'),
  children: [
    {
      path: 'map/:mapId',
      name: 'r_real-time-map',
      meta: {
        middlewares: {
          auth: null,
          permission: 'REAL_TIME',
          document: { applicationId: APPLICATIONS.APP_REAL_TIME.id },
          menuPreferences: 'REAL_TIME',
        },
      },
      component: () => import('../../components/realtime/RealtimeMap'),
    },
  ],
};
